'use client';

import { useMemo } from 'react';
/* eslint-disable @typescript-eslint/ban-types */
export const useThrottle = <T extends (...args: any) => any>(
  fn: T,
  wait: number,
): [throttledFunction: (...args: Parameters<T>) => void, clearThrottle: () => void] => {
  return useMemo(() => {
    let inThrottle: boolean, lastFn: ReturnType<typeof setTimeout>, lastTime: number;
    return [
      (...args: Parameters<T>) => {
        if (!inThrottle) {
          fn.apply(this, args);
          lastTime = Date.now();
          inThrottle = true;
        } else {
          clearTimeout(lastFn);
          lastFn = setTimeout(
            () => {
              if (Date.now() - lastTime >= wait) {
                fn.apply(this, args);
                lastTime = Date.now();
              }
            },
            Math.max(wait - (Date.now() - lastTime), 0),
          );
        }
      },
      () => {
        clearTimeout(lastFn);
        inThrottle = false;
        lastTime = 0;
      },
    ];
  }, [fn, wait]);
};
